<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(grantFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'grantFee') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "HrSalaryGrantDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'corpName', label: '公司名称', width: '140px'},
        {key: 'orgName', label: '部门名称', width: '120px'},
        {key: 'stationName', label: '岗位名称', width: '120px'},
        {key: 'employeeName', label: '员工姓名', width: '120px'},
        {key: 'idcarNo', label: '身份证号码', width: '130px'},
        {key: 'grantTypeLabel', label: '发放方式', width: '120px'},
        {key: 'bankName', label: '开户银行', width: '130px'},
        {key: 'bankAcct', label: '工资卡号', width: '120px'},
        {key: 'grantFee', label: '发放金额', width: '120px'},
        {key: 'grantContentLabel', label: '内容', width: '120px'},
      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total;
      }, 0).toFixed(2, Decimal.ROUND_HALF_UP);
    }
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
